import React from "react";
import { MovingWebsite } from "../../components/UnderConstruction";
import { InstaEmbedRow, PintEmbedRow } from "../../components/Embeds/components/embeds/EmbedRow";

export function artstickers() {
return ( 
 <>
<div className="row">
<div className="col"><MovingWebsite/>
</div>
</div>
<InstaEmbedRow
    url1="https://www.instagram.com/p/CkgMopMtfGV"
    url2="https://www.instagram.com/p/CTlNvzRp2y0"
    url3="https://www.instagram.com/p/CPiSRwSjBun"
/>
<PintEmbedRow
    url1="https://www.pinterest.de/pin/975029388055196720"
    url2="https://www.pinterest.de/pin/975029388055237221"
    url3="https://www.pinterest.de/pin/975029388055237319"
/>
<PintEmbedRow
    url1="https://www.pinterest.de/pin/975029388055237356"
    url2="https://www.pinterest.de/pin/975029388055237187"
    url3="https://www.pinterest.de/pin/975029388055237158"
/>
<InstaEmbedRow
    url1="https://www.instagram.com/p/Cjv3h26qgHu"
    url2="https://www.instagram.com/p/"
    url3="https://www.instagram.com/p/"
/>
<PintEmbedRow
    url1="https://www.pinterest.de/pin/975029388055237110"
    url2="https://www.pinterest.de/pin/975029388055237074"
    url3="https://www.pinterest.de/pin/975029388055237041"
/>
<PintEmbedRow
    url1="https://www.pinterest.de/pin/975029388055236876"
    url2="https://www.pinterest.de/pin/975029388055236801"
    url3="https://www.pinterest.de/pin/"
/>
</>
);
}

/* 
<InstaEmbedRow
    url1="https://www.instagram.com/p/"
    url2="https://www.instagram.com/p/"
    url3="https://www.instagram.com/p/"
/>

<PintEmbedRow
    url1="https://www.pinterest.de/pin/"
    url2="https://www.pinterest.de/pin/"
    url3="https://www.pinterest.de/pin/"
/>
 */